import { useStore } from "@/stores/useStore";
import { extractUserDisplayName } from "@/lib/users";

export const LoggedInUser = () => {
  const user = useStore((s) => s.user);
  return (
    <div className="text-xs">
      Logged in as: {user ? extractUserDisplayName(user) : "UNKNOWN USER"} (
      {user?.email})
    </div>
  );
};
